import React from 'react'

interface Props {
  progress: number | null
}
const ProgressBar = ({progress = 0}: Props) => {
  return (
    <div className="progress-bar">
      <div className="inner" style={{ width: `${progress}%` }} />
    </div>
  )
}

export default ProgressBar
